import React, { useState } from "react";

export const ImageUpload = ({ labelText = "Select Image", fileChange }) => {
  const [image, setImage] = useState(null);

  // Function to handle file input
  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
      fileChange(event.target.files[0]);
    }
  };

  return (
    <div className="p-5 rounded-lg flex flex-col items-center gap-5">
      <label htmlFor="imageInput" className="label">
        {labelText}
      </label>
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        className="w-3/5 cursor-pointer p-2.5 block mx-auto border-none rounded text-white file:bg-flyers-charcoal file:text-white file:border file:border-flyers-dark-gray file:rounded file:px-3 file:py-1 file:mr-3 file:cursor-pointer hover:file:bg-flyers-dark-gray"
      />
      {image && <img src={image} alt="Preview" className="max-w-xs rounded border-4 border-flyers-orange" style={{ height: "auto" }} />}
    </div>
  );
};
